import Image from "next/image";

import styled from "styled-components";

import { grayScale, red } from "@enkor/design/colors";
import { Typo } from "@enkor/design/components";

export const AVATAR_SIZE = 20;

export const Container = styled.div<{
  $spaceBetween?: boolean;
  $hasList?: boolean;
}>`
  display: flex;
  gap: ${({ $hasList }) => ($hasList ? "4px" : "0")};
  justify-content: ${({ $spaceBetween }) =>
    $spaceBetween ? "space-between" : "flex-start"};
`;

export const AvatarImageWrapper = styled.div<{ $withBorder?: boolean }>`
  position: relative;
  overflow: hidden;

  width: ${AVATAR_SIZE}px;
  height: ${AVATAR_SIZE}px;
  border: ${({ $withBorder }) =>
    $withBorder ? `1px solid ${grayScale.main}` : "none"};
  border-radius: 50%;
`;

// 간단한 유저 아바타 리스트를 위한 스타일드 컴포넌트
export const Avatars = styled.div`
  display: flex;
`;

export const AvatarWrapper = styled(AvatarImageWrapper)`
  margin-left: -4px;

  &:first-child {
    margin-left: 0;
  }
`;

export const Avatar = styled(Image)`
  object-fit: cover;

  width: 100%;
  height: 100%;
`;

export const DotsAvatarWrapper = styled(AvatarImageWrapper)`
  margin-left: -4px;
  padding: 0 3px;

  background-color: ${grayScale.white};
`;

export const AdditionalText = styled(Typo.Text)<{ $isFull?: boolean }>`
  color: ${({ $isFull }) => ($isFull ? red.main : grayScale[700])};
`;
